export default "__VITE_ASSET__521cdb96__"